/**
 * 將相對的照片 URL 轉換為完整的後端 URL
 * @param photoUrl 照片 URL（可能是相對路徑或完整 URL）
 * @returns 完整的照片 URL
 */
export const getFullPhotoUrl = (photoUrl: string): string => {
  // 如果已經是完整 URL，直接返回
  if (photoUrl.startsWith('http://') || photoUrl.startsWith('https://')) {
    return photoUrl;
  }

  // 獲取後端 API 基礎 URL
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';
  // 移除 /api 部分得到後端基礎 URL
  const backendBaseUrl = apiBaseUrl.replace('/api', '');

  // 如果 photoUrl 以 / 開頭，直接拼接
  if (photoUrl.startsWith('/')) {
    return `${backendBaseUrl}${photoUrl}`;
  }

  // 否則加上 /
  return `${backendBaseUrl}/${photoUrl}`;
};

